export default {
  en: {
    CCManagerCallList: {
      title: 'Call list',
    },
  },
};
